<template>
  <div id="app">
    <DraggableCal :accentColor="red" :years=5 @selectedDate="doSomething($event)"></DraggableCal>
  </div>
</template>
<script>
  /* eslint-disable */
  import DraggableCal from 'vue-draggable-cal';
  export default {
    return: {
      // items: [
      //   {
      //     src: 'https://cdn.vuetifyjs.com/images/carousel/squirrel.jpg'
      //   },
      //   {
      //     src: 'https://cdn.vuetifyjs.com/images/carousel/sky.jpg'
      //   },
      //   {
      //     src: 'https://cdn.vuetifyjs.com/images/carousel/bird.jpg'
      //   },
      //   {
      //     src: 'https://cdn.vuetifyjs.com/images/carousel/planet.jpg'
      //   }
      // ]
    },
    components: {
      DraggableCal,
    },
  }
</script>




// WEBPACK FOOTER //
// src/components/test/CalenderSinglePage.vue